import { logError } from 'libs/utils/window';

const errorsLogger = prefix => (error, feature) => {
  if (!(error instanceof Error)) return;
  const loggedFeature = feature ? "".concat(prefix, "_").concat(feature) : prefix;
  logError(error, {
    feature: loggedFeature
  });
};

export default errorsLogger;